module.exports = __webpack_public_path__ + "static/phtg-3ad2adee2e5b02d003e43ef1e1c3408a.svg";